import { Contact } from '../../api/contacts';
import { isManager } from '../../services/contact/GlobalPermissions';

export function canPickupForOthers(contact: Contact | undefined) {
    return contact !== undefined && isManager(contact);
}

export function canOrderForOthers(contact: Contact | undefined) {
    return contact !== undefined && isManager(contact);
}

export function canReturnForOthers(contact: Contact | undefined) {
    return contact !== undefined && isManager(contact);
}

export function canOrderOrthopedicShoes(contact: Contact | undefined) {
    return contact !== undefined && isManager(contact);
}
